import { createFileRoute } from "@tanstack/react-router";
import { StoreManagerPage } from "@/features/portalstore/StoreManagerPage";

/** The store manager (P2d): what each client sees in the portal store, and at what price. Static, so it wins over the tab route. */
export const Route = createFileRoute("/_app/catalogue/store")({
  component: StoreManagerPage,
});
